import React from 'react';
import { Select, Button, Toggle as BlueprintToggle } from '@resideo/blueprint-oneportal';
import styles from './primitives.module.css';
import { editIcon } from '@/assets/icons';

export const SectionHeading = (props: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2 {...props} className={[styles.sectionHeading, props.className].filter(Boolean).join(' ')} />
);

export const SubHeading = (props: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h3 {...props} className={[styles.subHeading, props.className].filter(Boolean).join(' ')} />
);

export const Desc = (props: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p {...props} className={[styles.desc, props.className].filter(Boolean).join(' ')} />
);

export const Divider = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.divider, props.className].filter(Boolean).join(' ')} />
);

export const SettingRow = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.settingRow, props.className].filter(Boolean).join(' ')} />
);

export const LabelTitle = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.labelTitle, props.className].filter(Boolean).join(' ')} />
);

export const LabelDesc = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.labelDesc, props.className].filter(Boolean).join(' ')} />
);

export const Control = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.control, props.className].filter(Boolean).join(' ')} />
);

/** Blueprint Select, min-width matched to previous custom dropdown */
export const StyledSelect = (props: React.ComponentProps<typeof Select>) => (
  <Select {...props} className={[styles.styledSelect, props.className].filter(Boolean).join(' ')} />
);

export const Toggle = ({ on, onChange }: { on: boolean; onChange: () => void }) => (
  <BlueprintToggle name="toggle" checked={on} onChange={onChange} />
);

export const InlineLabel = (props: React.HTMLAttributes<HTMLSpanElement>) => (
  <span {...props} className={[styles.inlineLabel, props.className].filter(Boolean).join(' ')} />
);

export const InlineRow = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.inlineRow, props.className].filter(Boolean).join(' ')} />
);

export const SettingsCard = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.settingsCard, props.className].filter(Boolean).join(' ')} />
);

export const CardHeader = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.cardHeader, props.className].filter(Boolean).join(' ')} />
);

export const CardTitle = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.cardTitle, props.className].filter(Boolean).join(' ')} />
);

export const CardGrid = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={[styles.cardGrid, props.className].filter(Boolean).join(' ')} />
);

export const CardGridItem = ({ label, value }: { label: string; value: string }) => (
  <div className={styles.cardGridItem}>
    <div className={styles.cardGridLabel}>{label}</div>
    <div className={styles.cardGridValue}>{value}</div>
  </div>
);

export const EditButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button {...props} className={[styles.editButton, props.className].filter(Boolean).join(' ')} type="button">
    <img src={editIcon} alt="" width={16} height={16} aria-hidden="true" />
  </button>
);

